import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/services';
import { ServiceDrawer } from './ServiceDrawer';
import type { Service, ServiceOption } from '../types/content';
interface ServicesProps {
  onRequestEstimate: (service: ServiceOption) => void;
}
export function Services({
  onRequestEstimate
}: ServicesProps) {
  const [active, setActive] = useState<Service | null>(null);
  return <section id="services" className="scroll-mt-20 bg-cyan-50 py-20 lg:py-28" aria-labelledby="services-title" data-id="element-294" data-mp="13x61w0v8odya">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-295" data-mp="z31vbipvy7xq">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between" data-id="element-296" data-mp="u7383ygamvyw">
          <h2 id="services-title" className="section-title max-w-2xl" data-id="element-297" data-mp="q59do7woyo76">
            Everything Your Pool Needs for a Fresh Start
          </h2>
          <p className="max-w-sm text-lg text-navy/70" data-id="element-298" data-mp="l7g6pcnkdq5u">
            Pick one upgrade or combine several. We handle each part of the renovation.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-299" data-mp="36boacyq5aedb">
          {services.map(service => <li key={service.id} className="flex" data-id="element-300" data-mp="3b4r7thy1m7ys">
              <button type="button" onClick={() => setActive(service)} className="group flex w-full flex-col overflow-hidden rounded-2xl bg-white text-left shadow-[0_1px_2px_rgba(6,55,101,0.06)] ring-1 ring-aqua/10 transition-shadow duration-200 ease-out hover:shadow-[0_12px_32px_-12px_rgba(10,37,64,0.25)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan" data-id="element-301" data-mp="2xcb92tc6cw3o">
                <span className="block aspect-[16/10] overflow-hidden" data-id="element-302" data-mp="3g1rf1w6mpgrh">
                  <img src={service.image} alt={service.imageAlt} className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-303" data-mp="3l0azfs5kqkhq" />
                </span>
                <span className="flex flex-1 flex-col p-6" data-id="element-304" data-mp="1pjug1587wscv">
                  <span className="font-display text-xl font-bold text-navy" data-id="element-305" data-mp="1pm6xlha2d0pe">{service.title}</span>
                  <span className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-306" data-mp="1lklq6bgateml">{service.description}</span>
                  <span className="mt-auto flex items-center gap-1.5 pt-5 text-[15px] font-semibold text-aqua" data-id="element-307" data-mp="1gpfskfdjabio">
                    Learn More
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-308" data-mp="16tuw0wr8i3gb" />
                  </span>
                </span>
              </button>
            </li>)}
        </ul>

        <div className="mt-6 flex flex-col gap-6 rounded-2xl bg-navy p-7 md:flex-row md:items-center md:justify-between md:p-10" data-id="element-309" data-mp="xurcxss2ho1t">
          <div className="max-w-2xl" data-id="element-310" data-mp="2s7h78bmckz9q">
            <h3 className="font-display text-2xl font-bold text-white md:text-3xl" data-id="element-311" data-mp="2s6fm1ebmawea">Full Pool Renovations</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/80 md:text-base" data-id="element-312" data-mp="2n8mcqcf0pm9s">
              Combine resurfacing, tile, coping, deck, and equipment work into one coordinated project with one team and
              one estimate.
            </p>
          </div>
          <button type="button" onClick={() => onRequestEstimate('Full Pool Renovation')} className="btn-primary w-full shrink-0 md:w-auto" data-id="element-313" data-mp="34i87u172rk6k">
            Get Your Free Estimate
          </button>
        </div>
      </div>

      <ServiceDrawer service={active} onClose={() => setActive(null)} onRequestEstimate={opt => {
      setActive(null);
      onRequestEstimate(opt);
    }} data-id="element-314" data-mp="2grchz9m6iz1y" />
    </section>;
}